import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    bulkTitle: (count: number) =>
      translate({ id: 'setup.vehicleAssignments.view.title.bulk', values: { count } }),
    delete: translate({ id: 'global.deleteAll' }),
    deleteNormalDay: translate({ id: 'setup.vehicleAssignments.deleteNormalDay.tooltip' }),
  }))

  return api
}
